import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export default function Main({ children, simpleHeader, isCookieBannerVisible, postTemplate }) {
  const mainRef = useRef(null);

  const childrenWithExtraProp = React.Children.map(children, child => {
    if (child) return React.cloneElement(child, { isCookieBannerVisible });
  });

  return (
    <StyledMain ref={mainRef} simpleHeader={simpleHeader} postTemplate={postTemplate}>
      {childrenWithExtraProp}
    </StyledMain>
  );
}

const dynamicSimpleHeaderMainStyle = ({ theme, simpleHeader }) => {
  return (
    !simpleHeader &&
    css`
      gap: ${theme.gap.component.mobile};
    `
  );
};

const dynamicOverflow = ({ postTemplate }) => {
  return (
    postTemplate &&
    css`
      @media only screen and (min-width: 1280px) {
        overflow: visible;
      }
    `
  );
};

const StyledMain = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-x: hidden;
  ${dynamicSimpleHeaderMainStyle};
  ${dynamicOverflow};
  @media only screen and (min-width: 1280px) {
    gap: 100px;
  }
`;
